import { usePlausible } from 'next-plausible';

export const usePlausibleEvents = () => {
  const plausible = usePlausible();

  return {
    onInlineComment: () => {
      plausible('inline-comment');
    },
    onComment: () => {
      plausible('comment');
    },
    onMarkdownImport: () => {
      plausible('import-markdown');
    },
    onMarkdownExport: () => {
      plausible('export-markdown');
    },
    onPdfExport: () => {
      plausible('export-pdf');
    },
    onSlidesShare: () => {
      plausible('slides-share');
    },
    onAccountMigrationSuccess: () => {
      plausible('account-migration-success', {
        props: {
          accountType: 'legacy',
        },
      });
    },
    onDocumentMigrationSuccess: (successInFirstAttempt: boolean) => {
      plausible('document-migration-success', {
        props: {
          accountType: 'legacy',
          successInFirstAttempt,
        },
      });
    },
    onDocumentMigrationFailed: (migrationAttempt: number) => {
      plausible('document-migration-failed', {
        props: {
          accountType: 'legacy',
          migrationAttempt,
        },
      });
    },
    onLoggedInVisit: (connectMedium: string) => {
      plausible('loggedIn-visitor', {
        props: {
          loginMethod: connectMedium,
        },
      });
    },
    onLogInPlausible: () => {
      plausible('Existing User Login');
    },
    onSignUpPlausible: () => {
      plausible('New User Sign Up');
    },
    onOwnerLoginPlausible: (connectMedium: string) => {
      plausible(`${connectMedium}-login`);
    },
    onOwnerWalletLoginPlausible: (walletName: string) => {
      plausible('walletAddress-login', {
        props: {
          wallet: walletName,
        },
      });
    },
    onVisitorCopyHeadingLinkPlausible: () => {
      plausible('Copy heading link reader');
    },
  };
};
